import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { RoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';

import localeCa from '@angular/common/locales/ca';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { MockInterceptor } from './core/interceptors/mock.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { ClickToCallComponent } from './modules/click-to-call/click-to-call.component';
import { ConfirmacionSiniestroComponent } from './modules/confirmacion-siniestro/confirmacion-siniestro.component';
import { DatosContactoComponent } from './modules/datos-contacto/datos-contacto.component';
import { DatosSiniestroComponent } from './modules/datos-siniestro/datos-siniestro.component';
import { LlamanosComponent } from './modules/llamanos/llamanos.component';
import { AltaSiniestroComponent } from './modules/alta-siniestro/alta-siniestro.component';
import { ConfirmComponent } from './shared/components/confirm/confirm.component';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { LocaleService } from './shared/services/locale.service';
import { UrgenciaComponent } from './modules/urgencia/urgencia.component';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeCa, 'ca');

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}
@NgModule({
	declarations: [
		AppComponent,
		DatosSiniestroComponent,
		DatosContactoComponent,
		ConfirmacionSiniestroComponent,
		AltaSiniestroComponent,
		LoaderComponent,
		ConfirmComponent,
		ClickToCallComponent,
		LlamanosComponent,
		UrgenciaComponent
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MockInterceptor,
			multi: true
		},
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true
		},
		{
			provide: LOCALE_ID,
			deps: [LocaleService],
			useValue: 'es', //variable para cambiar el componente calendar 'es', 'en', 'ca' Funciona! (INTERESA QUE SEA DINÁMICA)
			useFactory: (localeService: LocaleService) => localeService.locale
		}
	],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RoutingModule,
		NgbModule,
		MatToolbarModule,
		MatMenuModule,
		MatIconModule,
		MatStepperModule,
		MatFormFieldModule,
		MatButtonModule,
		MatInputModule,
		MatDatepickerModule,
		MatNativeDateModule,
		CarouselModule,
		HttpClientModule,
		ReactiveFormsModule,
		FormsModule,
		HttpClientModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		SharedModule,
		OAuthModule.forRoot()
	]
})
export class AppModule {}
